// See README.md for more info about field configuration

import { FIELD_TYPE } from '@/constants'

import _get from 'lodash/get'

export const newLandlordPropMgr = {
  collectionItemUniqueId: '',
  name: '',
  phoneNumber: ''
}

export default function getLandlordPropMgr(key) {
  return {
    apiKey: key,
    type: FIELD_TYPE.COLLECTION,
    collapsible: true,
    showLine: true,
    heading(item,index) {
      return `Landlord/Property Manager ${index}`
    },
    headingAdd:  'Add Landlord/Property Manager',
    headingAddOutline: true,
    newItem: { ...newLandlordPropMgr },
    fields(item, index) {
      var apiKeyPrefix = `shelter.landlordPropMgr.landlordPropMgrDetails[${index}]`
            
            return [
              {
                apiKey: `${apiKeyPrefix}.name`,
                label: 'Name',
                placeHolder: 'Enter name',
                type: FIELD_TYPE.NAME,
                maxLength: 100,
                required: true
              },
              {
                apiKey: `${apiKeyPrefix}.phoneNumber`,
                label: 'Phone number',
                placeHolder: 'Enter phone number',
                required: true,
                maxLength: 100
              },
            ]
          }
    }
  }

